import { useLink, useLocation } from "@grandvisionhq/frk-routing";
import { sha256 } from "@grandvisionhq/lib-utils-w3c";
const useRedirects = ({ message } = {}) => {
  const loginPageLink = useLink({ route: "returns", params: { message } });
  const confirmationPageLink = useLink({
    route: "returns.confirmation",
    params: { email: "", orderNumber: "" }
  });
  const { push } = useLocation();
  const redirectToLogin = () => {
    const fallbackRoute = `/returns${message ? `?message=${message}` : ""}`;
    const location = loginPageLink?.href ?? fallbackRoute;
    push(location);
    return;
  };
  const redirectToConfirmation = async (params) => {
    const hashedEmail = await sha256(params.email.toLowerCase());
    const fallbackRoute = `/returns/confirmation?email=${hashedEmail}&orderNumber=${params.orderNumber}`;
    const location = confirmationPageLink?.href ?? fallbackRoute;
    push(location);
    return;
  };
  return {
    redirectToLogin,
    redirectToConfirmation
  };
};
export {
  useRedirects
};
//# sourceMappingURL=use-redirects.js.map
